import React, { useCallback } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle';

import FontAwesome from 'utils/FA';
import { present } from 'utils/strings';

const Appointment = (
  {
    calendar_name,
    contact_data: {
      first_name: studentFirstName,
      last_name: studentLastName,
      grade,
      year
    },
    contact_id,
    email,
    end_time,
    first_name,
    id,
    phone,
    last_name,
    start_date,
    start_time,
    video_conferencing_link,
    onCancel
  }
) => (
  <div className='appointment-list-appointment'>
    <div className='appointment-list-appointment-time'>
      <div className='appointment-list-appointment-time-of-day'>
        {`${start_time} - ${end_time}`}
      </div>
      <div className='appointment-list-appointment-date'>
        {moment(start_date).format('dddd, MMMM Do, YYYY')}
      </div>
    </div>
    <div className='appointment-list-appointment-info'>
      <div className='appointment-list-appointment-calendar-name'>{calendar_name}</div>
      <div className='appointment-list-appointment-student'>
        <span>Student: </span>
        {
          contact_id !== 'public'
            ? <a href={`/contacts/${contact_id}`}>{`${studentFirstName} ${studentLastName}`}</a>
            : <span>{`${studentFirstName} ${studentLastName}`}</span>
        }
        {`, ${grade} Grade / ${year}`}
      </div>
      <div className='appointment-list-appointment-contact'>
        Contact:
        {` ${first_name} ${last_name}${present(phone) || present(email) ? ',' : ''}`}
        {present(phone) ? ` ${phone}` : null}
        {present(email) ? `${present(phone) ? ' / ' : ''}${email}` : null}
      </div>

      {video_conferencing_link && <div className='appointment-list-appointment-contact'>
        Video Conferencing Link: <a href={video_conferencing_link}>{video_conferencing_link}</a>
      </div>}
    </div>

    <div className='appointment-list-appointment-cancel'>
      <button
        className='btn btn-sm btn-danger'
        type='button'
        onClick={useCallback(() => onCancel({
          id,
          first_name,
          last_name,
          email,
          phone
        }), [id, first_name, last_name, email, phone])}
      >
        <FontAwesome icon={faTimesCircle} />
        &nbsp;Cancel Appointment
      </button>
    </div>
  </div>
);


Appointment.propTypes = {
  /** Name of the calendar the appointment is tied to   */
  calendar_name: PropTypes.string,

  /** Data on the appointment attendee  */
  contact_data: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    grade: PropTypes.string,
    year: PropTypes.string
  }),

  /** The id of the contact who booked the appointment */
  contact_id: PropTypes.string,

  /** The email address of the contact who booked the appointment */
  email: PropTypes.string,

  /** The end time of the available time the appointment is booked into */
  end_time: PropTypes.string,

  /** The first name of the contact who booked the appointment */
  first_name: PropTypes.string,

  /** The appointment's id */
  id: PropTypes.string,

  /** The phone number of the contact who booked the appointment */
  phone: PropTypes.string,

  /** The last name of the contact who booked the appointment */
  last_name: PropTypes.string,

  /** The start date of the available time the appointment is booked into */
  start_date: PropTypes.string,

  /** The start time of the available time the appointment is booked into */
  start_time: PropTypes.string,

  /** Called when an appointment is cancelled */
  onCancel: PropTypes.func
};

Appointment.defaultProps = {
  calendar_name: '',
  contact_data: {
    first_name: '',
    last_name: '',
    grade: '',
    year: ''
  },
  contact_id: '',
  email: '',
  end_time: '',
  first_name: '',
  id: '',
  phone: '',
  last_name: '',
  start_date: '',
  start_time: '',

  onCancel: () => false
};

export default Appointment;
